import DualloDashboardClient from '@/clients/duallo/DualloDashboardClient';

class DashboardService {

    async getDashboardsByAssetId(assetId){
        return await DualloDashboardClient.getDashboardsByAssetId(assetId);
    }
}

export default new DashboardService();